import { useEffect } from 'react';
import { useEditNotificationReadStateMutation } from 'store/services/core/notification';
import { useGetUserAgendaNotificationsQuery } from 'store/services/core/userNotifications';

type UseMarkRecordInfoNotificationsAsReadProps = {
  recordId: string;
  agendaId: string;
};

export const useMarkRecordInfoNotificationsAsRead = ({ recordId, agendaId }: UseMarkRecordInfoNotificationsAsReadProps) => {
  const [editNotificationReadState] = useEditNotificationReadStateMutation();
  const { data: notifications } = useGetUserAgendaNotificationsQuery(
    { actionRequired: false, agendaIds: [agendaId] },
    { skip: !recordId || !agendaId }
  );

  useEffect(() => {
    if (!recordId || !agendaId || !notifications?.length) return;

    const notificationIds = notifications
      .filter((notification) => notification.recordId === recordId && !notification.requiresAction)
      .map((notification) => notification.id);

    if (notificationIds.length === 0) return;

    const markAsRead = async () => {
      try {
        await editNotificationReadState({
          userNotificationsIds: notificationIds,
          state: 'Read',
        }).unwrap();
      } catch {
        return;
      }

      window.dispatchEvent(new CustomEvent('flowio:refresh-notifications'));
    };

    markAsRead();
  }, [recordId, agendaId, notifications, editNotificationReadState]);
};
